export const FETCH_VALIDATE_OTP_REQUEST = 'FETCH_VALIDATE_OTP_REQUEST'
export const FETCH_VALIDATE_OTP_SUCCESS = 'FETCH_VALIDATE_OTP_SUCCESS'
export const FETCH_VALIDATE_OTP_FALUIRE = 'FETCH_VALIDATE_OTP_FALUIRE'
